import  { useEffect, useState } from "react";

export default function Navbar({
  onMenuClick,
  onSearchSend,
}: {
  onMenuClick?: () => void;
  onSearchSend?: (query: string) => void;
}) {
  const [scrolled, setScrolled] = useState(false);
  const [search, setSearch] = useState("");
  const [userName, setUserName] = useState("Yaswanth");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Listen for userChanged event to update userName
  useEffect(() => {
    const handleUserChanged = () => {
      setUserName(localStorage.getItem("userName") || "User");
    };
    window.addEventListener("userChanged", handleUserChanged);
    return () => window.removeEventListener("userChanged", handleUserChanged);
  }, []);

  // Handle send (icon click or enter)
  const handleSend = () => {
    if (search.trim()) {
      onSearchSend?.(search.trim());
      setSearch("");
    }
  };

  // Handle Enter key
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <header
      className="
        top-0 left-0
        w-full
        h-20
        flex flex-row justify-between items-center
        px-4 md:px-8
        border-b border-[#E8E8E8]
        z-50
        box-border
        bg-white
      "
      style={{
        background: "rgba(244, 245, 247, 1)",
        borderBottom: scrolled ? "1px solid #e2e8f0" : "none",
        boxShadow: scrolled ? undefined : "none",
      }}
    >
      {/* Hamburger for mobile */}
      <button
        className="md:hidden mr-3"
        onClick={onMenuClick}
        aria-label="Open sidebar"
      >
        <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M4 7h20M4 14h20M4 21h20" />
        </svg>
      </button>

      {/* Left: Greeting and Date */}
      <div className="flex flex-row items-center gap-3">
        <span
          style={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "28px",
            letterSpacing: "0%",
            color: "rgba(25, 25, 25, 1)",
          }}
        >
          {`Hello ${userName}`}
        </span>
        <div className="hidden md:flex flex-row items-center">
          {/* Combined double right arrows */}
          <svg
            width="24"
            height="14"
            viewBox="0 0 24 14"
            fill="none"
            style={{
              color: "rgba(159, 159, 159, 1)",
              verticalAlign: "middle",
            }}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3 1l5 6-5 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 1l5 6-5 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
            <span
            style={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "20px",
              letterSpacing: "0%",
              color: "rgba(159, 159, 159, 1)",
              marginLeft: "4px",
            }}
            >
            {new Date().toLocaleDateString(undefined, {
              year: "numeric",
              month: "short",
              day: "numeric",
            })}
            </span>
        </div>
      </div>

      {/* Right: Notification and Search */}
      <div className="flex items-center gap-6">
        {/* Notification icon as PNG */}
        {/* <img
          src="/Notification_icon.png"
          alt="Notifications"
          style={{ width: "24px", height: "24px", objectFit: "contain" }}
          className="hidden md:block"
        /> */}
        {/* Search box */}
        <div className="relative w-full max-w-[352px] hidden md:block">
          <input
            type="text"
            placeholder="Search here"
            style={{
              width: "100%",
              height: "48px",
              paddingTop: "12px",
              paddingRight: "24px",
              paddingBottom: "12px",
              paddingLeft: "32px",
              borderRadius: "12px",
              background: "rgba(255, 255, 255, 1)",
              fontFamily: "Inter, sans-serif",
              fontWeight: 400,
              fontSize: "16px",
              lineHeight: "24px",
              letterSpacing: "0%",
              color: "rgba(25, 25, 25, 1)",
              border: "none",
              outline: "none",
              minWidth: 0,
            }}
            className="shadow"
            value={search}
            onChange={e => setSearch(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <style>
            {`
              input::placeholder {
                font-family: Inter, sans-serif;
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
                letter-spacing: 0%;
                color: rgba(159, 159, 159, 1);
                opacity: 1;
              }
            `}
          </style>
          <span className="absolute right-6 top-1/2 -translate-y-1/2 text-[#A3A3A3] cursor-pointer">
            {search.trim() ? (
              // Send icon (paper plane)
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
                onClick={handleSend}
                style={{ cursor: "pointer" }}
              >
                <path
                  d="M22 2L11 13"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22 2L15 22L11 13L2 9L22 2Z"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              // Search icon
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <circle cx="11" cy="11" r="8" />
                <path d="M21 21l-4.35-4.35" strokeLinecap="round" />
              </svg>
            )}
          </span>
        </div>
      </div>
    </header>
  );
}